import Papa from "papaparse";

export function computationHelper(aggregatedData = {}, objects = []) {
  const completed = objects?.filter((obj) => obj.status === "C");
  const voided = objects?.filter((obj) => obj.status === "V");

  const transactionTypes = Object.values(aggregatedData).flatMap((storeData) =>
    Object.keys(storeData)
  );

  const uniqueTransactionTypes = [...new Set(transactionTypes)];

  const totals = completed.reduce(
    (acc, o) => {
      const t = Number(o.total) || 0;
      acc.gross += t;
      acc.discount += Number(o.discount_amount) || 0;
      acc.pretax += Number(o.total_pretax) || 0;
      acc.tax += Number(o.total_tax) || 0;
      acc.taxFree += Number(o.total_taxfree) || 0;
      acc.net += t - (Number(o.total_tax) || 0);
      return acc;
    },
    { gross: 0, discount: 0, pretax: 0, tax: 0, taxFree: 0, net: 0 }
  );

  const voidTotals = voided.reduce(
    (acc, o) => {
      acc.amount += Number(o.total) || 0;
      return acc;
    },
    { amount: 0 }
  );
  const voidCount = voided.length;

  const sortedStores = Object.keys(aggregatedData || {}).sort();

  return {
    totals,
    // uniqueTransactionTypes,
    voidTotals: { amount: voidTotals.amount, count: voidCount },
    // sortedStores,
  };
}

/**
 * @param {Object} params
 * @param {Object} params.aggregatedData  – same shape as in your state
 * @param {Array}  params.objects         – full objects array from state
 * @param {string} params.startDate       – formatted start date
 * @param {string} params.endDate         – formatted end date
 */
export function exportReportCSV({
  aggregatedData = {},
  objects = [],
  startDate = "",
  endDate = "",
}) {
  const filtered = objects.filter((obj) => obj.status === "C");

  const allTransactionTypes = [
    "Delivery",
    "Dine In",
    "Take Out",
    "GrabFood",
    "FoodPanda",
    "Pick Up",
    "Del Time",
    "Drive-thru",
    "Tablevibe",
    "undefined",
  ];

  const summaryTotals = filtered.reduce(
    (acc, o) => {
      const t = Number(o.total) || 0;
      acc.gross += t;
      acc.discount += Number(o.discount_amount) || 0;
      acc.pretax += Number(o.total_pretax) || 0;
      acc.tax += Number(o.total_tax) || 0;
      acc.taxFree += Number(o.total_taxfree) || 0;
      return acc;
    },
    { gross: 0, discount: 0, pretax: 0, tax: 0, taxFree: 0 }
  );

  summaryTotals.net = summaryTotals.gross - summaryTotals.tax;

  const dataRows = Object.keys(aggregatedData).map((store) => {
    const storeData = aggregatedData[store] || {};
    const row = { Store: store };

    const totalNet = allTransactionTypes.reduce(
      (sum, type) => sum + (storeData[type]?.netSale || 0),
      0
    );
    const totalCount = allTransactionTypes.reduce(
      (sum, type) => sum + (storeData[type]?.tc || 0),
      0
    );

    allTransactionTypes.forEach((type) => {
      const { netSale = 0, tc = 0 } = storeData[type] || {};
      const percentage =
        totalNet > 0 ? ((netSale / totalNet) * 100).toFixed(2) : "0.00";

      row[`${type} Net Sale`] = netSale;
      row[`${type} TC`] = tc;
      row[`${type} Percentage`] = percentage;
    });

    row["Total Net Sale"] = totalNet;
    row["Total Count"] = totalCount;
    return row;
  });

  dataRows.push({
    Store: "Summary Totals",
    "Gross Sales": summaryTotals.gross,
    "Total Discount Amount": summaryTotals.discount,
    "Total Pretax": summaryTotals.pretax,
    "Total Tax": summaryTotals.tax,
    "Total Tax Free": summaryTotals.taxFree,
    "Net Sales": summaryTotals.net,
  });

  const csvHeaders = [
    "Store",
    ...allTransactionTypes.flatMap((type) => [
      `${type} Net Sale`,
      `${type} TC`,
      `${type} Percentage`,
    ]),
    "Total Net Sale",
    "Total Count",
    "Gross Sales",
    "Total Discount Amount",
    "Total Pretax",
    "Total Tax",
    "Total Tax Free",
    "Net Sales",
  ];

  const csv = Papa.unparse({ fields: csvHeaders, data: dataRows });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", `report-${startDate}-to-${endDate}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
